import React from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-white',
    borderColor: 'border-[#e2e8f0]',
    textColor: 'text-[#5c4033]',
    emoji: '📗',
    title: 'FUNDAMENTOS DE LA PRODUCCIÓN AGROPECUARIA',
    subtitle: 'La base que necesitás para entender todo lo demás',
    desc: 'Sistemas y regiones productivas de Argentina y el mundo · Recursos naturales y su rol en la producción · Cadenas agropecuarias de principio a fin · Cómo se organiza y funciona el sistema productivo completo.',
    resuelve: 'El primer contacto con el mundo agropecuario puede ser el más revelador o el más confuso. Este tomo convierte un sistema complejo en algo claro, lógico y apasionante desde la primera página.',
    resultado: 'Entendés el campo como un sistema integrado, no como temas sueltos que no se conectan entre sí.'
  }, {
    id: 2,
    lightColor: 'bg-white',
    borderColor: 'border-[#e2e8f0]',
    textColor: 'text-[#5c4033]',
    emoji: '📘',
    title: 'AGRICULTURA, SUELOS, FERTILIZACIÓN Y RIEGO',
    subtitle: 'El corazón técnico de la producción agrícola',
    desc: 'Tipos de suelo y sus propiedades productivas · Fundamentos de fertilización y nutrición vegetal · Sistemas de riego y manejo del agua en agricultura · Cultivo de la tierra con enfoque técnico y didáctico.',
    resuelve: 'Suelos, fertilización y riego son los pilares de cualquier producción. Este tomo te da el dominio técnico completo sobre cómo funciona la tierra y cómo manejarla correctamente.',
    resultado: 'Dominás los fundamentos del manejo agrícola con bases sólidas que podés aplicar en la práctica.'
  }, {
    id: 3,
    lightColor: 'bg-white',
    borderColor: 'border-[#e2e8f0]',
    textColor: 'text-[#5c4033]',
    emoji: '📙',
    title: 'MAQUINARIA AGRÍCOLA, GANADERÍA Y PRODUCCIÓN SUSTENTABLE',
    subtitle: 'Los tres pilares que modernizaron el campo',
    desc: 'Maquinaria agrícola y su rol en la modernización del campo · Ganadería como sistema productivo esencial · Producción sustentable — cuidar los recursos mientras se produce · Contenidos con ilustraciones y actividades integradas.',
    resuelve: 'Este tomo conecta tres temas fundamentales que en otros materiales aparecen separados: cómo la tecnología transformó el campo, cómo funciona la ganadería como sistema productivo y por qué la sustentabilidad ya no es opcional.',
    resultado: 'Entendés cómo el campo moderno combina tecnología, producción animal y cuidado ambiental en un solo sistema.'
  }, {
    id: 4,
    lightColor: 'bg-white',
    borderColor: 'border-[#e2e8f0]',
    textColor: 'text-[#5c4033]',
    emoji: '📕',
    title: 'AGROINDUSTRIA, ECONOMÍA RURAL, SEGURIDAD, GESTIÓN Y TECNOLOGÍA',
    subtitle: 'El campo que no se ve desde afuera — pero que lo mueve todo',
    desc: 'Agroindustria — transformación de productos primarios · Economía rural y toma de decisiones productivas · Gestión agropecuaria — planificación, organización y control · Tecnología de punta aplicada al campo moderno · Seguridad e higiene en establecimientos agropecuarios.',
    resuelve: 'Producir es solo una parte. Transformar, gestionar, comercializar y aplicar tecnología es lo que convierte una actividad agropecuaria en un negocio rentable y sustentable. Este tomo te da esa visión completa.',
    resultado: 'Tenés la visión completa del sistema agropecuario — desde el campo hasta la góndola, desde la producción hasta la gestión.'
  }];
  const librosEspecializacion = [{
    title: 'Gestión y Economía Agropecuaria',
    tema: 'Decisiones, rentabilidad y estrategia',
    aprende: 'Cómo organizar y planificar un sistema productivo para maximizar resultados económicos'
  }, {
    title: 'Suelos y Fertilización Avanzada',
    tema: 'Edafología y nutrición vegetal',
    aprende: 'Formación, composición y manejo del suelo como sistema vivo y productivo'
  }, {
    title: 'Sistemas de Riego e Hidrología',
    tema: 'Manejo hídrico en agricultura',
    aprende: 'Sistema suelo-planta-atmósfera, evapotranspiración y programación hídrica sustentable'
  }, {
    title: 'Tecnologías en el Agro',
    tema: 'Innovación y digitalización',
    aprende: 'Agricultura de precisión, inteligencia artificial y automatización en sistemas productivos modernos'
  }];
  const librosGanaderia = [{
    id: 1,
    title: 'Introducción a la Ganadería y Producción Animal',
    desc: 'Sistemas de producción, clasificación de especies y bases del manejo ganadero.'
  }, {
    id: 2,
    title: 'Anatomía y Fisiología Animal',
    desc: 'Sistemas anatómicos y fisiología aplicada a la producción animal.'
  }, {
    id: 3,
    title: 'Nutrición y Alimentación Animal',
    desc: 'Requerimientos nutricionales, formulación de dietas y estrategias de alimentación.'
  }, {
    id: 4,
    title: 'Reproducción Animal',
    desc: 'Fisiología reproductiva, manejo y técnicas de mejoramiento genético.'
  }, {
    id: 5,
    title: 'Sanidad Animal',
    desc: 'Enfermedades por especie, planes sanitarios y bioseguridad.'
  }, {
    id: 6,
    title: 'Producción Bovina (Módulo Estrella)',
    desc: 'Cría, recría, engorde y tambo completos.'
  }, {
    id: 7,
    title: 'Producción Porcina',
    desc: 'Sistemas modernos, manejo reproductivo y sanitario, conversión alimenticia.'
  }, {
    id: 8,
    title: 'Producción Aviar',
    desc: 'Carne y huevos, manejo de galpones, control sanitario y rendimiento.'
  }, {
    id: 9,
    title: 'Instalaciones Ganaderas',
    desc: 'Diseño, infraestructura para manejo y criterios técnicos de construcción.'
  }, {
    id: 10,
    title: 'Bienestar Animal',
    desc: 'Principios, indicadores e impacto en la productividad y calidad.'
  }, {
    id: 11,
    title: 'Producción Sustentable',
    desc: 'Manejo de recursos naturales y estrategias para menor impacto ambiental.'
  }];
  const bonos = [{
    id: 1,
    title: 'Actividades de Agricultura y Suelos'
  }, {
    id: 2,
    title: 'Evaluaciones de Ganadería'
  }, {
    id: 3,
    title: 'Prácticas de Maquinaria y Sustentabilidad'
  }, {
    id: 4,
    title: 'Ejercicios de Agroindustria y Tecnología'
  }];
  return <section className="py-20 bg-[#fdfbf7]" data-id="element-166">
      <div className="container mx-auto px-4" data-id="element-167">
        <div className="text-center mb-16 max-w-4xl mx-auto" data-id="element-168">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1a3622] text-[#fdfbf7] border border-[#2c4c3b] font-bold mb-6 text-[16px]" data-id="element-169">
            🏆 El sistema más completo en español
          </div>
          <h2 className="md:text-5xl font-extrabold text-[#1a3622] mb-4 text-[24px]" data-id="element-170">
            MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360
          </h2>
          <p className="text-[#4a3b32] font-medium text-[18px] mb-6" data-id="element-171">
            4 tomos principales · 12 libros especializados · 4 cuadernos de
            actividades · Todo listo para usar desde hoy.
          </p>
          <div className="bg-[#f5f0e6] p-6 rounded-xl border border-[#d4af37]/50 text-left md:text-center text-[#5c4033]" data-id="element-172">
            <p data-id="element-173">No es teoría copiada de un manual universitario.</p>
            <p data-id="element-174">No es una colección de archivos sueltos sin orden.</p>
            <p data-id="element-175">
              No es material que tengas que reescribir entero para que sirva.
            </p>
            <p className="font-bold mt-2 text-[#1a3622]" data-id="element-176">
              Es un sistema organizado en bloques que te lleva desde los
              fundamentos del suelo hasta la producción animal avanzada — con
              claridad, profundidad técnica y lenguaje que realmente se
              entiende.
            </p>
          </div>
        </div>

        {/* 4 Tomos Principales */}
        <div className="text-center mb-12" data-id="element-177">
          <h3 className="text-3xl font-extrabold text-[#1a3622] mb-2" data-id="element-178">
            📗 LOS 4 TOMOS PRINCIPALES
          </h3>
          <p className="text-[#5c4033]" data-id="element-179">
            La columna vertebral del sistema agropecuario — completa y
            organizada
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-180">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#e2e8f0] bg-white overflow-hidden shadow-lg hover:shadow-xl hover:border-[#d4af37] transition-all flex flex-col h-full relative" data-id="element-181">
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-182">
                <div className="text-3xl" data-id="element-183">{tomo.emoji}</div>
                <div data-id="element-184">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-185">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-[#1a3622] text-lg leading-tight" data-id="element-186">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-187">
                <p className="font-semibold text-[#8b5a2b] mb-3 pb-3 border-b border-[#e2e8f0]" data-id="element-188">
                  {tomo.subtitle}
                </p>
                <div className="bg-[#f5f0e6] p-3 rounded-lg mb-4 border border-[#e2e8f0]" data-id="element-189">
                  <p className="text-xs text-[#5c4033] mb-1" data-id="element-190">
                    <strong data-id="element-191">¿Qué resuelve?</strong>
                  </p>
                  <p className="text-sm text-[#4a3b32]" data-id="element-192">{tomo.resuelve}</p>
                </div>
                <ul className="text-[#4a3b32] text-sm leading-relaxed mb-4 space-y-2" data-id="element-193">
                  {tomo.desc.split('·').map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-194">
                      <span className="text-[#d4af37]" data-id="element-195">✔</span> {item.trim()}
                    </li>)}
                </ul>
                <div className="bg-[#1a3622]/5 p-3 rounded-lg mt-auto border border-[#1a3622]/10" data-id="element-196">
                  <p className="text-xs text-[#1a3622] mb-1" data-id="element-197">
                    <strong data-id="element-198">Resultado:</strong>
                  </p>
                  <p className="text-sm text-[#2c4c3b] font-medium" data-id="element-199">
                    {tomo.resultado}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* 4 Libros Especialización */}
        <div className="text-center mb-12 border-t border-[#e2e8f0] pt-16" data-id="element-200">
          <h3 className="text-3xl font-extrabold text-[#1a3622] mb-2" data-id="element-201">
            🔬 LOS 4 LIBROS DE ESPECIALIZACIÓN TÉCNICA
          </h3>
          <p className="text-[#5c4033]" data-id="element-202">
            Profundización en los temas que más necesitás dominar
          </p>
        </div>

        <div className="max-w-6xl mx-auto mb-20 overflow-x-auto" data-id="element-203">
          <table className="w-full text-left border-collapse bg-white rounded-xl overflow-hidden shadow-sm border border-[#e2e8f0]" data-id="element-204">
            <thead data-id="element-205">
              <tr className="bg-[#1a3622] text-white" data-id="element-206">
                <th className="p-4 font-bold" data-id="element-207">LIBRO</th>
                <th className="p-4 font-bold" data-id="element-208">TEMA</th>
                <th className="p-4 font-bold" data-id="element-209">LO QUE APRENDÉS</th>
              </tr>
            </thead>
            <tbody data-id="element-210">
              {librosEspecializacion.map((libro, i) => <tr key={i} className="border-b border-[#e2e8f0] hover:bg-[#f5f0e6] transition-colors" data-id="element-211">
                  <td className="p-4 font-bold text-[#1a3622]" data-id="element-212">
                    {libro.title}
                  </td>
                  <td className="p-4 text-[#8b5a2b] font-medium" data-id="element-213">
                    {libro.tema}
                  </td>
                  <td className="p-4 text-[#4a3b32] text-sm" data-id="element-214">
                    {libro.aprende}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* 11 Libros Ganadería */}
        <div className="text-center mb-12 border-t border-[#e2e8f0] pt-16" data-id="element-215">
          <h3 className="text-3xl font-extrabold text-[#1a3622] mb-2" data-id="element-216">
            🐄 LOS 11 LIBROS DE GANADERÍA 360°
          </h3>
          <p className="text-[#5c4033]" data-id="element-217">
            De cero a avanzado — La formación ganadera más completa en español
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto mb-20" data-id="element-218">
          {librosGanaderia.map(libro => <div key={libro.id} className="bg-white border border-[#e2e8f0] p-5 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-219">
              <h4 className="text-[#d4af37] font-bold text-sm mb-1 uppercase tracking-wider" data-id="element-220">
                {libro.id === 6 ? 'MÓDULO 6' : `LIBRO ${libro.id}`}
              </h4>
              <h5 className="font-bold text-[#1a3622] mb-2" data-id="element-221">{libro.title}</h5>
              <p className="text-[#5c4033] text-sm" data-id="element-222">{libro.desc}</p>
            </div>)}
        </div>

        {/* Bonos */}
        <div className="text-center mb-12 border-t border-[#e2e8f0] pt-16" data-id="element-223">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#d4af37] text-[#1a3622] font-bold mb-6 text-[16px]" data-id="element-224">
            🎁 EL BONO EXCLUSIVO — Solo disponible en este pack
          </div>
          <h2 className="md:text-4xl font-extrabold text-[#1a3622] mb-4 text-[22px]" data-id="element-225">
            SISTEMA DE ACTIVIDADES Y EVALUACIONES AGROPECUARIAS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-226">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#e2e8f0] bg-white p-6 flex flex-col h-full relative overflow-hidden shadow-md" data-id="element-227">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#d4af37] to-[#f1d570]" data-id="element-228"></div>
              <h4 className="font-bold text-[#8b5a2b] mb-2 mt-2" data-id="element-229">
                TOMO BONO {bono.id}
              </h4>
              <h3 className="font-bold text-[#1a3622] text-lg mb-3" data-id="element-230">
                {bono.title}
              </h3>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-gradient-to-br from-[#1a3622] to-[#2c4c3b] rounded-2xl p-6 md:p-8 border border-[#d4af37] text-center shadow-2xl" data-id="element-231">
          <p className="text-[#fdfbf7] font-medium mb-4 text-lg" data-id="element-232">
            Sin respuestas precargadas. Aprendizaje activo real. El material que
            hace que el conocimiento se fije de verdad.
          </p>
          <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-233">
            Valor real: $9.990 →{' '}
            <span className="text-[#d4af37]" data-id="element-234">INCLUIDO GRATIS</span>
          </p>
          <p className="text-[#cbd5e1] text-sm mt-4" data-id="element-235">
            Este bono no se vende por separado. Solo está disponible cuando
            llevás el pack completo hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}